module.exports = __webpack_public_path__ + "img/billboard_tenet_cgr.bab89147.jpg";